var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLedLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.6665L16.6667 2.49984M2.5 1.6665L3.33333 2.49984M17.5 13.3332L16.6667 12.4998M2.5 13.3332L3.33333 12.4998M7.5 14.9998H12.5M8.33333 17.4998H11.6667M9.99983 2.49984C6.66642 2.49984 4.95988 4.12508 4.99987 6.6665C5.01937 7.90558 5.41642 8.74984 6.24987 9.58317C7.08333 10.4165 7.5 10.8332 7.49988 12.4998H12.4998C12.5 10.8333 12.9167 10.4165 13.7498 9.58325C14.583 8.74992 14.9804 7.90558 14.9998 6.6665C15.0398 4.12508 13.3333 2.49984 9.99983 2.49984Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLedLighting);
export default __webpack_public_path__ + "static/media/icon-led-lighting.abfc481555c8dc5c3f27ce7d6b5ab9c3.svg";
export { ForwardRef as ReactComponent };